import { createAction, createAsyncAction } from "typesafe-actions";

import type { FetchError } from "app/pages/sales-intelligence/types";

import type { AssignableUser } from "../types/common";

export const fetchAssignableUsersAsync = createAsyncAction(
    "@@si/assign-to-users/assignable-users-fetch-started",
    "@@si/assign-to-users/assignable-users-fetch-succeeded",
    "@@si/assign-to-users/assignable-users-fetch-failed",
)<void, AssignableUser[], FetchError>();

export const assignToUserAsync = createAsyncAction(
    "@@si/assign-to-users/assign-started",
    "@@si/assign-to-users/assign-succeeded",
    "@@si/assign-to-users/assign-failed",
)<void, void, FetchError>();

export const setIsShowAssignToUserModal = createAction("@@si/assign-to-users/is-show-assign-to-user-modal")<boolean>();
